var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6368_453)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6368_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.125 3.25L24.925 3.2875L18.25 5.875L10.75 3.25L3.7 5.625C3.4375 5.7125 3.25 5.9375 3.25 6.225V25.125C3.25 25.475 3.525 25.75 3.875 25.75L4.075 25.7125L10.75 23.125L18.25 25.75L25.3 23.375C25.5625 23.2875 25.75 23.0625 25.75 22.775V3.875C25.75 3.525 25.475 3.25 25.125 3.25ZM12 6.3375L17 8.0875V22.6625L12 20.9125V6.3375ZM5.75 7.575L9.5 6.3125V20.9375L5.75 22.3875V7.575ZM23.25 21.425L19.5 22.6875V8.075L23.25 6.625V21.425Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6368_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6368_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(-0.5 -0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2c3d023e261f12ddb487b8ea9f06a336.svg";
export { ForwardRef as ReactComponent };